import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import TravelSection from "./discoverSection";
import Travelpackage from "./popularPackage";
import Traveldetails from "./dreamDiv";
import Traveldestination from "./dealSection";
import Travelexplore from "./Travelexplore";
import Travelfeedback from "./Travelfeedback";
import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";

export default function Home() {
  return (
    <>
      <section className="home-container">
        <div className="navbar-absolute-wrapper">
          <Navbarsticky />
        </div>

        <Row className="position-relative">
          <Col>
            <div
              className="d-flex flex-column justify-content-center mt-5 align-items-center text-center home-text z-1"
              style={{
                position: "relative",
              }}
            >
              <h5
                className="text-white fw-semibold text-center fade-slide-up fade-delay-1"
                style={{
                  fontSize: "clamp(32px, 6vw, 70px)",
                  lineHeight: "2",
                  marginTop: "3rem",
                }}
              >
                Andaman Island Escape
              </h5>

              <p
                className="text-white mt-3 fade-slide-up fade-delay-2"
                style={{ maxWidth: "650px", fontSize: "20px" }}
              >
                Unwind amid crystal-clear seas, vibrant coral reefs, and serene
                white shores — an oasis of pure tropical bliss awaits you.
              </p>

              <Link
                to="/tour-packages"
                className="tour-btn mt-5 mb-3 fade-slide-up fade-delay-3"
              >
                TAKE A TOUR <span>→</span>
              </Link>
            </div>
          </Col>
        </Row>
      </section>

      {/*Discover andaman  */}

      <TravelSection />

      {/*Most popular   */}

      <Travelpackage />

      {/*discover next trip */}

      <Traveldetails />

      {/*deal destination  */}

      <Traveldestination />

      {/*Travel Explore  */}

      <Travelexplore />

      {/*Travel feedback  */}

      <Travelfeedback />

      <Footer />
    </>
  );
}
